import React from 'react';
import { ReactComponent as Phone } from '../assets/icons/Phone.svg';
import { ReactComponent as Favorite } from '../assets/icons/Favorite.svg';
import { ReactComponent as Icon1 } from '../assets/icons/Icon1.svg';
import { ReactComponent as FavoriteHeader } from '../assets/icons/FavoriteHeader.svg';
import { ReactComponent as CompareHeader } from '../assets/icons/CompareHeader.svg';
import { ReactComponent as IconNotFound } from '../assets/icons/NotFound.svg';
import { ReactComponent as ExternalLinkIcon } from '../assets/icons/ExternalLink.svg';
import { ReactComponent as Ball } from '../assets/icons/Ball.svg';
import { ReactComponent as Scales } from '../assets/icons/Scales.svg';
import { ReactComponent as HotSale } from '../assets/icons/HotSale.svg';
import { ReactComponent as Close } from '../assets/icons/Close.svg';
import { ReactComponent as Dropdown } from '../assets/icons/Dropdown.svg';
import { ReactComponent as IconMoreInfo } from '../assets/icons/IconMoreInfo.svg';
import { ReactComponent as ShareIcon } from '../assets/icons/humbleicons_share.svg';
import { ReactComponent as ShareLinkIcon } from '../assets/icons/humbleicons_share_link.svg';
import { ReactComponent as SharePrintIcon } from '../assets/icons/ion_print-outline.svg';
import { ReactComponent as ScalePreviewPlus } from '../assets/icons/Scale+.svg'
import { ReactComponent as ScalePreviewMinus } from '../assets/icons/Scale–.svg'
import { ReactComponent as MapPreviewIcon } from '../assets/icons/location.fill.svg'
import { ReactComponent as ArrowIcon } from '../assets/icons/footer-arrow.svg'
import { ReactComponent as DeleteIcon } from '../assets/icons/Delete.svg'
import { ReactComponent as SuccessIcon } from '../assets/icons/Success.svg'
import { ReactComponent as EyesIcon } from '../assets/icons/EyesIcon.svg'
import { ReactComponent as FilterNotFoundIcon} from '../assets/icons/FilterNotFoundIcon.svg'
import { ReactComponent as NewsNotFoundIcon} from '../assets/icons/NewsNotFoundIcon.svg'
import { ReactComponent as TelegramIcon } from '../assets/icons/TelegramIcon.svg'
import { ReactComponent as VkIcon} from '../assets/icons/VkIcon.svg'
import { ReactComponent as YoutubeIcon} from '../assets/icons/YoutubeIcon.svg'
import { ReactComponent as HomeIcon } from '../assets/icons/HomeIcon.svg'
import { ReactComponent as SupportIcon } from '../assets/icons/SupportIcon.svg'
import { ReactComponent as NewsIcon } from '../assets/icons/NewsIcon.svg'
import { ReactComponent as LoaderLogo } from '../assets/icons/LoaderLogo.svg'
import { ReactComponent as BankIcon } from '../assets/icons/BankIcon.svg'
import { ReactComponent as ClockIcon } from '../assets/icons/ClockIcon.svg'
import { ReactComponent as PercentIcon } from '../assets/icons/PercentIcon.svg'

export type IconProps = {
  name:
    | 'icon1'
    | 'icon2'
    | 'icon3'
    | 'iconNotFound'
    | 'externalLinkIcon'
    | 'ball'
    | 'scales'
    | 'hotSale'
    | 'closeIcon'
    | 'dropdownIcon'
    | 'feature'
    | 'iconMoreInfo'
    | 'share_icon'
    | 'shareLinkIcon'
    | 'sharePrintIcon'
    | 'favorite_header'
    | 'compare_header'
    | 'scalePlus'
    | 'scaleMinus'
    | 'locationIcon'
    | 'arrowIcon'
    | 'deleteIcon'
    | 'successIcon'
    | 'eyesIcon'
    | 'filterNotFoundIcon'
    | 'newsNotFoundIcon'
    | 'telegramIcon'
    | 'vkIcon'
    | 'youtubeIcon'
    | 'homeIcon'
    | 'supportIcon'
    | 'newsIcon'
    | 'loaderLogo'
    | 'bankIcon'
    | 'clockIcon'
    | 'percentIcon'
  width?: string;
  height?: string;
  fill?: string;
  className?: string;
  onClick?: () => void;
};

const Icon: React.FC<IconProps> = ({
  name,
  width = '24',
  height = '24',
  fill = 'none',
  className,
  onClick,
}) => {
  const icons: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
    icon1: Phone,
    icon2: Favorite,
    icon3: Icon1,
    iconNotFound: IconNotFound,
    externalLinkIcon: ExternalLinkIcon,
    ball: Ball,
    scales: Scales,
    hotSale: HotSale,
    closeIcon: Close,
    dropdownIcon: Dropdown,
    iconMoreInfo: IconMoreInfo,
    share_icon: ShareIcon,
    shareLinkIcon: ShareLinkIcon,
    sharePrintIcon: SharePrintIcon,
    favorite_header: FavoriteHeader,
    compare_header: CompareHeader,
    scalePlus: ScalePreviewPlus,
    scaleMinus: ScalePreviewMinus,
    locationIcon: MapPreviewIcon,
    arrowIcon: ArrowIcon,
    deleteIcon: DeleteIcon,
    successIcon: SuccessIcon,
    eyesIcon: EyesIcon,
    filterNotFoundIcon: FilterNotFoundIcon,
    newsNotFoundIcon: NewsNotFoundIcon,
    telegramIcon: TelegramIcon,
    vkIcon: VkIcon,
    youtubeIcon: YoutubeIcon,
    homeIcon: HomeIcon,
    supportIcon: SupportIcon,
    newsIcon: NewsIcon,
    loaderLogo: LoaderLogo,
    bankIcon: BankIcon,
    clockIcon: ClockIcon,
    percentIcon: PercentIcon
  };

  const SvgIcon = icons[name];

  return (
    <SvgIcon
      width={width}
      height={height}
      fill={fill}
      className={className}
      onClick={onClick}
    />
  );
};

export default Icon;